<template>
  <div class="product-list">
    <cart-product
      v-for="cartItem of checkoutCartItems"
      :key="getName(cartItem)"
      :cart-item="cartItem"
      class="product-list__product"
      :multiplier-update-disabled="multiplierUpdateDisabled"
      :has-notification="hasNotification"
    />
  </div>
</template>

<script>
import { clamp } from 'ramda';
import { mapGetters } from 'vuex';

import CartProduct from '@/components/cart/CartProduct.vue';

import { getCartItemName, CartItem } from '@/models/core/CartItem';
import { getProductOptionsDefaultOption } from '@/models/core/ProductOptions';
import { getProductPackStockQuantity } from '@/models/core/ProductPack';

import { types } from '@/store/types';
import { PRODUCT_NAMES } from '@/constants/treatment';

export default {
  name: 'ProductList',
  components: { CartProduct },
  props: {
    multiplierUpdateDisabled: {
      type: Boolean,
      default: false
    },
    hasNotification: {
      type: Boolean,
      default: false
    },
    includeFreeSample: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      allProductOptionsSet: types.getters.ALL_PRODUCT_OPTIONS_SETS,
      cartItems: types.getters.CART_ITEMS
    }),
    checkoutCartItems() {
      if (this.includeFreeSample) {
        const freeSamplePack = getProductOptionsDefaultOption(
          this.allProductOptionsSet[PRODUCT_NAMES.FREE_SAMPLE]
        );
        const quantity = clamp(0, 3, getProductPackStockQuantity(freeSamplePack));

        if (quantity > 0) {
          const freeSampleCartItem = CartItem(freeSamplePack, quantity);

          return [...this.cartItems, freeSampleCartItem];
        }
      }

      return this.cartItems;
    }
  },
  methods: {
    getName(item) {
      return getCartItemName(item);
    }
  }
};
</script>
